export const FACEBOOK_PAGES_NODE = 'facebookPages';

export const CLOUD_FUNCTIONS = {
  GET_LONG_LIVED_USER_ACCESS_TOKEN: 'facebookGetLongLivedUserAccessToken',
  GET_FEED: 'facebookGetPageFeed',
};
